module.exports = __webpack_public_path__ + "images/emoji/aquarius.7818568071cabcd68266.png";